module.exports = __webpack_public_path__ + "static/media/Decoration_Hawaii.8f7b6b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Hawaii.png
// module id = 1350
// module chunks = 3